exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rotator-1-wrapper[data-v-710cb2cb]{width:auto;max-width:410px;padding-bottom:10px}.rg-rotator-1-content[data-v-710cb2cb]{min-width:350px}", ""]);

// exports
